import { useDictStore } from "@/stores/dictStore";

import { PricingStrategy, PriceResult } from "../base/pricing.strategy";
import { CutsHolesTypeCode } from "@/app/constants/hardwares";

export class DoorCutsPricingStrategy extends PricingStrategy {
    private dictStore = useDictStore();

    public getPrices(): PriceResult {
        const pricesFromDict =
            this.dictStore.findDoorAdditionalCostsPrice(CutsHolesTypeCode);

        if (!this.validatePricesFromDict(pricesFromDict)) {
            return this.getDefaultPrices();
        }

        return {
            price: pricesFromDict.price!,
            priceB2C: pricesFromDict.priceB2C!,
            priceB2B: pricesFromDict.priceB2B!,
        };
    }
}
